// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2RF-2","iconStyle":"Header_iconStyle__3r1r2","dynamicHeaderRight":"Header_dynamicHeaderRight__2X3BN","rightWrapper":"Header_rightWrapper__3BJrE"};